import { createSelector } from 'reselect';

const aiAgentsState = (state) => state.AiAgent.aiAgents;
const leadFieldsState = (state) => state.LeadField.leadFields;

export const selectAiAgents = () =>
  createSelector(aiAgentsState, (aiAgents) => aiAgents);

export const selectAiAgent = (aiAgentId) =>
  createSelector(
    aiAgentsState,
    (aiAgents) => aiAgents.find(({ id }) => id === aiAgentId) || null,
  );

export const selectAiAgentsByChannel = (channel) =>
  createSelector(aiAgentsState, (aiAgents) =>
    aiAgents.filter((aiAgent) => aiAgent.channel === channel),
  );

export const selectResolvedCollectFields = (aiAgentId) =>
  createSelector(
    selectAiAgent(aiAgentId),
    leadFieldsState,
    (aiAgent, leadFields) => {
      if (!aiAgent || !Array.isArray(aiAgent.collectFields)) return [];

      return aiAgent.collectFields.reduce(
        (acc, { leadFieldId, required, overwrite, hint }) => {
          const leadField = leadFields.find(({ id }) => id === leadFieldId);
          if (!leadField) return acc;

          return [
            ...acc,
            {
              leadFieldId,
              name: leadField.name,
              typeField: leadField.typeField,
              listValues: leadField.listValues || [],
              required: !!required,
              overwrite: !!overwrite,
              hint: hint || '',
            },
          ];
        },
        [],
      );
    },
  );
